import { React } from 'react'
import SortingCustomIcon from '../../widgets/SortingCustomIcon'
import {
	getLocalDateFromUTC,
	getFormattedDate,
} from '../../widgets/CustomDateRangePicker/CustomDateRangePicker.utils'
import { MAX_ACCOUNT_NAME_LENGTH } from '../Customers/customers.constants'
import { truncate } from 'lodash'

export const CARD_TITLE = {
	TOTALS: 'Totals',
	COMMISSION: 'Billing',
}

export const CREATE_CUSTOMER_MODAL = 'CreateCustomerModal'
export const DELETE_DOCUMENT_MODAL = 'DeleteDocumentModal'

export const TOTALS_MODAL = {
	TOTAL_ACCOUNTS: 'Total Accounts',
	TOTAL_FFLS: 'Total FFLs',
	TOTAL_DOCUMENTS: 'Total Documents',
	TOTAL_ATF_AUDITS: 'Total ATF Audits',
	TOTAL_ATF_AUDITORS: 'Total ATF Auditors',
	TOTAL_GREEN_FLAGS_BY_FFLS: 'Total Green Flags by FFLs',
	TOTAL_GREEN_FLAGS_BY_ATF: 'Total Green Flags by ATF',
	TOTAL_YELLOW_FLAGS_BY_FFLS: 'Total Yellow Flags by FFLs',
	TOTAL_YELLOW_FLAGS_BY_ATF: 'Total Yellow Flags by ATF',
	TOTAL_RED_FLAGS_BY_FFLS: 'Total Red Flags by FFLs',
	TOTAL_Red_FLAGS_BY_ATF: 'Total Red Flags by ATF',
}

export const COMMISSION_MODAL = {
	TOTAL_COMMISION: 'Total Commission',
	COMMISSION_DETAILS: 'Commission Details',
	TOTAL_CUSTOMERS: 'Total Customers',
	TOTAL_NEW_CUSTOMERS: 'Total New Customers',
	RENEWING_CUSTOMERS: 'Renewing Customers',
	TOTAL_CHURNED_CUSTOMERS: 'Total Churned Customers',
	UNENGAGED_USERS: 'Unengaged Users',
	LIFETIME_VALUE: 'Lifetime Value',
	NEW_MRR: 'New MRR',
	AVG_PRODUCT_MIX: 'Avg Product Mix',
}

export const COMMISSION_TYPE = {
	Total: 'Total',
	New: 'New',
	AwaitingPayment: 'AwaitingPayment',
	Renewed: 'Renewed',
	Updated: 'Updated',
}

export const COMMISSION_DEAL_TYPE = {
	0: 'Total',
	1: 'New',
	2: 'AwaitingPayment',
	3: 'Renewing',
	4: 'Updated',
}

export const FilterOperators = {
	Equal: 0,
	NotEqual: 1,
	GreaterThan: 2,
	GreaterThanOrEqual: 3,
	LessThan: 4,
	LessThanOrEqual: 5,
	Between: 6,
	NotBetween: 7,
	IsEmpty: 8,
	NotEmpty: 9,
}

export const FilterTypes = {
	DynamicOperation: 0,
	Numeric: 1,
	Boolean: 2,
	DateRange: 3,
	String: 4,
	CheckBox: 5,
}

export const filterOperatorsText = {
	0: '=',
	1: '!=',
	2: '>',
	3: '>=',
	4: '<',
	5: '<=',
	6: 'between',
	7: 'not between',
	8: 'is empty',
	9: 'is not empty',
}

const commaFormatter = (number) =>
	number && number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')

export const getFormattedPlanName = (phrase) =>
	phrase &&
	phrase
		.toLowerCase()
		.split(/[\s_-]+/)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ')

export const getFormattedTitle = (accountName, row) =>
	accountName && accountName.length > MAX_ACCOUNT_NAME_LENGTH ? accountName : ''

export const numberWithCommas = (number) => {
	return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
}

export const getFormattedCurrency = (number) => {
	return number != null
		? `$${numberWithCommas(number && number.toFixed(2))}`
		: ''
}

function getFormattedCommissionDealType(commissionType) {
	return COMMISSION_DEAL_TYPE[commissionType]
}

export const getFormattedAccountName = (id, row) => {
	const account = row.account || row.accountName
	const formattedAccountName = truncate(account, {
		length: MAX_ACCOUNT_NAME_LENGTH,
		ommission: '...',
	})

	return formattedAccountName
}

function UrlFormatter(url, anchorText) {
	if (url && anchorText)
		return (
			<a href={url} target={'_blank'} rel={'noreferrer'}>
				{anchorText}
			</a>
		)
	else return <></>
}

export const CommissionsTableRowClassFormatter = (row, rowIndex) => {
	if (row?.expectedDealAmount !== row?.actualDealAmount)
		return 'text-table-data bg-Unknown'
	else return 'text-table-data'
}

export const TOTALS_COLUMNS = {
	TOTAL_ACCOUNTS: [
		{
			dataField: 'account',
			text: 'Account',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalDocuments',
			text: 'Total Documents',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
	TOTAL_FFLS_DOCUMENTS: [
		{
			dataField: 'fflName',
			text: 'FFL Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'account',
			text: 'Account',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalDocuments',
			text: 'Total Documents',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
	TOTAL_ATF_AUDITS: [
		{
			dataField: 'fflName',
			text: 'FFL Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'account',
			text: 'Account',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalAuditor',
			text: 'Total Auditors',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'auditStartDate',
			text: 'Audit Start Date',
			formatter: getLocalDateFromUTC,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'auditEndDate',
			text: 'Audit End Date',
			formatter: getLocalDateFromUTC,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
	TOTAL_ATF_AUDITORS: [
		{
			dataField: 'fflName',
			text: 'FFL Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'account',
			text: 'Account',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'auditorName',
			text: 'Auditor Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'auditStartDate',
			text: 'Audit Start Date',
			formatter: getLocalDateFromUTC,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'auditEndDate',
			text: 'Audit End Date',
			formatter: getLocalDateFromUTC,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
	TOTAL_GREEN_FLAGS_BY_FFLS: [
		{
			dataField: 'fflName',
			text: 'FFL Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'account',
			text: 'Account',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalDocumentsFlaggedGreenByFflUser',
			text: 'Total Documents Flagged Green by FFL users',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
	TOTAL_YELLOW_FLAGS_BY_FFLS: [
		{
			dataField: 'fflName',
			text: 'FFL Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'account',
			text: 'Account',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalDocumentsFlaggedYellowByFflUser',
			text: 'Total Documents Flagged Yellow by FFL users',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
	TOTAL_RED_FLAGS_BY_FFLS: [
		{
			dataField: 'fflName',
			text: 'FFL Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'account',
			text: 'Account',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalDocumentsFlaggedRedByFflUser',
			text: 'Total Documents Flagged Red by FFL users',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
	TOTAL_GREEN_FLAGS_BY_ATF: [
		{
			dataField: 'fflName',
			text: 'FFL Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'account',
			text: 'Account',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalDocumentsFlaggedGreenByAtfUser',
			text: 'Total Documents Flagged Green by ATF users',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
	TOTAL_YELLOW_FLAGS_BY_ATF: [
		{
			dataField: 'fflName',
			text: 'FFL Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'account',
			text: 'Account',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalDocumentsFlaggedYellowByAtfUser',
			text: 'Total Documents Flagged Yellow by ATF users',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
	TOTAL_Red_FLAGS_BY_ATF: [
		{
			dataField: 'fflName',
			text: 'FFL Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'account',
			text: 'Account',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalDocumentsFlaggedRedByAtfUser',
			text: 'Total Documents Flagged Red by ATF users',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
}

export const COMMISSION_COLUMNS = {
	COMMISSION_DETAILS: [
		{
			dataField: 'accountName',
			text: 'Account Name',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'dealName',
			text: 'Deal Name',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'planDescription',
			text: 'Plan Description',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'termDate',
			text: 'Term Date',
			sort: true,
			sortCaret: SortingCustomIcon,
			formatter: getFormattedDate,
		},
		{
			dataField: 'expectedDealAmount',
			text: 'Expected Amount',
			sort: true,
			sortCaret: SortingCustomIcon,
			formatter: getFormattedCurrency,
		},
		{
			dataField: 'actualDealAmount',
			text: 'Actual Amount',
			sort: true,
			sortCaret: SortingCustomIcon,
			formatter: getFormattedCurrency,
		},
		{
			dataField: 'expectedDealCommission',
			text: 'Expected Commission',
			sort: true,
			sortCaret: SortingCustomIcon,
			formatter: getFormattedCurrency,
		},
		{
			dataField: 'actualDealCommission',
			text: 'Actual Commission',
			sort: true,
			sortCaret: SortingCustomIcon,
			formatter: getFormattedCurrency,
		},
		{
			dataField: 'commissionDealType',
			text: 'Commission Deal Type',
			sort: true,
			sortCaret: SortingCustomIcon,
			formatter: getFormattedCommissionDealType,
		},
	],
	COMMISSION_DEAL_LINKS: [
		{
			dataField: 'dealMatchStatus',
			text: 'Deal Match Status',
			title: getFormattedTitle,
		},
		{
			dataField: 'crmDealUrl',
			text: 'CRM Deal',
			title: getFormattedTitle,
			formatter: (id, row) => UrlFormatter(row.crmDealUrl, row.crmDealId),
		},
		{
			dataField: 'billingSubscriptionUrl',
			text: 'Billing subscription',
			title: getFormattedTitle,
			formatter: (id, row) =>
				UrlFormatter(row.billingSubscriptionUrl, row.billingSiteSubscriptionId),
		},
	],
	TOTAL_COMMISION: [
		{
			dataField: 'accountName',
			text: 'Account Name',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalSale',
			text: 'Total Sales',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalCommission',
			text: 'Total Commission',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
	TOTAL_CUSTOMERS: [
		{
			dataField: 'accountName',
			text: 'Account Name',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalSale',
			text: 'Total Sales',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'subscriptionPlan',
			text: 'Subscription Plan',
			sort: true,
			formatter: getFormattedPlanName,
			sortCaret: SortingCustomIcon,
		},
	],
	TOTAL_NEW_CUSTOMERS: [
		{
			dataField: 'accountName',
			text: 'Account Name',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'subscriptionPlan',
			text: 'Subscription Plan',
			sort: true,
			formatter: getFormattedPlanName,
			sortCaret: SortingCustomIcon,
		},

		{
			dataField: 'accountCreationDate',
			text: 'Account Creation Date',
			sort: true,
			formatter: getLocalDateFromUTC,
			sortCaret: SortingCustomIcon,
		},
	],
	RENEWING_COUSTOMERS: [
		{
			dataField: 'accountName',
			text: 'Account Name',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalSale',
			text: 'Total Sales',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'subscriptionPlan',
			text: 'Subscription Plan',
			sort: true,
			formatter: getFormattedPlanName,
			sortCaret: SortingCustomIcon,
		},
	],
	TOTAL_CHURNED_COUSTOMERS: [
		{
			dataField: 'accountName',
			text: 'Account Name',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalSale',
			text: 'Total Sales',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},

		{
			dataField: 'churnDate',
			text: 'Churn Date',
			sort: true,
			sortCaret: SortingCustomIcon,
			formatter: getLocalDateFromUTC,
		},

		{
			dataField: 'subscriptionPlan',
			text: 'Subscription Plan',
			sort: true,
			formatter: getFormattedPlanName,
			sortCaret: SortingCustomIcon,
		},
	],
	UNENGAGED_USER: [
		{
			dataField: 'accountName',
			text: 'Account Name',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'userName',
			text: 'User Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'lastLoginDate',
			text: 'Last Login Date',
			sort: true,
			formatter: getLocalDateFromUTC,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'subscriptionPlan',
			text: 'Subscription Plan',
			sort: true,
			formatter: getFormattedPlanName,
			sortCaret: SortingCustomIcon,
		},
	],
	LIFE_TIME_VALUE: [
		{
			dataField: 'accountName',
			text: 'Account Name',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'subscriptionPlan',
			text: 'Subscription Plan',
			sort: true,
			formatter: getFormattedPlanName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalSale',
			text: 'Total Sales',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
	NEW_MRR: [
		{
			dataField: 'accountName',
			text: 'Account Name',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'subscriptionPlan',
			text: 'Subscription Plan',
			sort: true,
			formatter: getFormattedPlanName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'monthlySubscriptionPlan',
			text: 'Monthly Subscription',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'totalSale',
			text: 'Total Sales',
			formatter: commaFormatter,
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	],
	AVG_PRODUCT_MIX: [
		{
			dataField: 'accountName',
			text: 'Account Name',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'userName',
			text: 'User Name',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'subscriptionPlan',
			text: 'Subscription Plan',
			sort: true,
			formatter: getFormattedPlanName,
			sortCaret: SortingCustomIcon,
		},
	],
}

export const DATE_RANGE_FILTERS = [
	// TODO: Needs to update once the displayed engagement chart will be confirmed.
	// {
	// 	id: 1,
	// 	value: 'Today',
	// },
	// {
	// 	id: 2,
	// 	value: 'Yesterday',
	// },
	{
		id: 3,
		value: 'This Week So Far',
	},
	{
		id: 4,
		value: 'Last Week',
	},
	{
		id: 5,
		value: 'This Month So Far',
	},
	{
		id: 6,
		value: 'Last Month',
	},
	{
		id: 7,
		value: 'Custom Date Range',
	},
	{
		id: 8,
		value: 'All Time',
	},
]
